import {
  getMemberById,
  clearGetMemberById,
  updateMember,
} from "../../../Redux/Members/MembersActions";
import { getAllBuildings } from "../../../Redux/Buildings/BuildingActions";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { Link, useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import arrowIcon from "../../../Assets/arrowleft.png";
import React, { useEffect, useState } from "react";
import validator from "../../../Util/validator";
import styles from "./EditMember.module.scss";
import moment from "moment";

function EditMember() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { buildings } = useSelector((state: RootState) => state.buildings);

  const { memberById, updateMemberLoading, memberByIdLoading } = useSelector(
    (state: RootState) => state.members,
  );

  const [buildingId, setBuildingId] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [idNumber, setIdNumber] = useState<string>("");
  const [unit, setUnit] = useState<string>("");
  const [startDate, setStartDate] = useState<string>(
    moment().format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState<string>(
    moment().add(1, "month").format("YYYY-MM-DD"),
  );
  const [onHold, setOnHold] = useState<string>("false");
  const [isActive, setIsActive] = useState<string>("true");
  const [accessKeyName, setAccessKeyName] = useState<string>("");
  const [accessKey, setAccessKey] = useState<string>("");
  const [errors, setErrors] = useState<{
    buildingId: string;
    firstName: string;
    lastName: string;
    email: string;
    idNumber: string;
    unit: string;
    startDate: string;
    endDate: string;
    onHold: string;
    isActive: string;
    accessKeyName: string;
    accessKey: string;
  }>({
    buildingId: "",
    firstName: "",
    lastName: "",
    email: "",
    idNumber: "",
    unit: "",
    startDate: "",
    endDate: "",
    onHold: "",
    isActive: "",
    accessKeyName: "",
    accessKey: "",
  });

  const addMemberHandler = () => {
    const { errors: fieldErrors, isValid } = validator([
      {
        key: "buildingId",
        type: "text",
        value: buildingId,
      },
      {
        key: "firstName",
        type: "text",
        value: firstName,
      },
      {
        key: "lastName",
        type: "text",
        value: lastName,
      },
      {
        key: "email",
        type: "email",
        value: email,
      },
      {
        key: "idNumber",
        type: "text",
        value: idNumber,
      },
      {
        key: "unit",
        type: "text",
        value: unit,
      },
      {
        key: "startDate",
        type: "date",
        value: startDate,
      },
      {
        key: "endDate",
        type: "date",
        value: endDate,
      },
      {
        key: "onHold",
        type: "text",
        value: onHold,
      },
      {
        key: "isActive",
        type: "text",
        value: isActive,
      },
      {
        key: "accessKeyName",
        type: "text",
        value: accessKeyName,
      },
      {
        key: "accessKey",
        type: "text",
        value: accessKey,
      },
    ]);
    setErrors({ ...errors, ...fieldErrors });

    if (isValid) {
      if (!updateMemberLoading && id) {
        const successHandler = () => {
          navigate("/admin/members", {
            replace: true,
          });
        };

        dispatch(
          updateMember({
            memberId: parseInt(id),
            buildingId: parseInt(buildingId),
            firstName,
            lastName,
            email,
            idNumber,
            unit,
            startDate,
            endDate,
            onHold: onHold === "true",
            isActive: isActive === "true",
            accessKeyName,
            accessKey,
            successHandler,
          }),
        );
      }
    }
  };

  useEffect(() => {
    dispatch(getAllBuildings());
    if (id) {
      dispatch(getMemberById({ memberId: Number(id) }));
    }
    return () => {
      dispatch(clearGetMemberById());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (memberById) {
      setBuildingId(memberById?.building?.buildingId?.toString() || "");
      setFirstName(memberById?.member?.firstName || "");
      setLastName(memberById?.member?.lastName || "");
      setEmail(memberById?.member?.email || "");
      setIdNumber(memberById?.member?.nationalId || "");
      setUnit(memberById?.lease?.unit || "");
      setStartDate(
        moment(memberById?.lease?.startDate).format("YYYY-MM-DD") ||
          moment().format("YYYY-MM-DD"),
      );
      setEndDate(
        moment(memberById?.lease?.endDate).format("YYYY-MM-DD") ||
          moment().add(1, "month").format("YYYY-MM-DD"),
      );
      setOnHold(memberById?.lease?.onHold?.toString() || "false");
      setIsActive(memberById?.member?.isActive?.toString() || "true");
      setAccessKeyName(memberById?.accessKey?.name || "");
      setAccessKey(memberById?.accessKey?.key || "");
    }
  }, [memberById]);

  if (memberByIdLoading) {
    return <Loading />;
  }

  return (
    <div className={styles.mainContainer}>
      <Link to="/admin/members" replace className={styles.backButtonContainer}>
        <button className={styles.button}>
          <img src={arrowIcon} alt="arrowIcon" className={styles.arrowIcon} />
          Back to Members
        </button>
      </Link>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Edit Members</h1>
      </div>
      <div className={styles.formContainer}>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Building</p>
          <select
            className={styles.input}
            value={buildingId}
            onChange={(e) => setBuildingId(e.target.value)}
          >
            {!buildingId && <option value="">Select Building</option>}
            {buildings?.map((building) => (
              <option key={building.buildingId} value={building.buildingId}>
                {building.buildingName}
              </option>
            ))}
          </select>
          <p className={styles.error}>{errors.buildingId}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>First Name</p>
          <input
            type="text"
            className={styles.input}
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          <p className={styles.error}>{errors.firstName}</p>
        </div>
        <div className={styles.doubleInputContainer}>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Last Name</p>
            <input
              type="text"
              className={styles.input}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            <p className={styles.error}>{errors.lastName}</p>
          </div>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Email</p>
          <input
            type="text"
            className={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <p className={styles.error}>{errors.email}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>National ID</p>
          <input
            type="text"
            className={styles.input}
            value={idNumber}
            onChange={(e) => setIdNumber(e.target.value)}
          />
          <p className={styles.error}>{errors.idNumber}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Unit</p>
          <input
            type="text"
            className={styles.input}
            value={unit}
            onChange={(e) => setUnit(e.target.value)}
          />
          <p className={styles.error}>{errors.unit}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Start Date</p>
          <input
            type="date"
            className={styles.input}
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <p className={styles.error}>{errors.startDate}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>End Date</p>
          <input
            type="date"
            className={styles.input}
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
          <p className={styles.error}>{errors.endDate}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>On Hold</p>
          <select
            className={styles.input}
            value={onHold}
            onChange={(e) => setOnHold(e.target.value)}
          >
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
          <p className={styles.error}>{errors.onHold}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Status</p>
          <select
            className={styles.input}
            value={isActive}
            onChange={(e) => setIsActive(e.target.value)}
          >
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>
          <p className={styles.error}>{errors.isActive}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Access Key Name</p>
          <input
            type="text"
            className={styles.input}
            value={accessKeyName}
            onChange={(e) => setAccessKeyName(e.target.value)}
          />
          <p className={styles.error}>{errors.accessKeyName}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Access Key</p>
          <input
            type="text"
            className={styles.input}
            value={accessKey}
            onChange={(e) => setAccessKey(e.target.value)}
          />
          <p className={styles.error}>{errors.accessKey}</p>
        </div>

        {updateMemberLoading && <Loading />}

        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={addMemberHandler}>
            Update Member
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditMember;
